import React, { useEffect, useState } from 'react';
import { formatMoney } from '../../helpers/formatters';

export const CartItem = ({ item, onChange, onRemove }) => {
    const [quantity, setQuantity] = useState(item.quantity);

    useEffect(() => {
        setQuantity(item.quantity);
    }, [item.quantity]);

    const computeAmount = () => {
        return Number(item.product.price) * Number(item.quantity);
    };

    const handleUpdate = (e) => {
        const value = Number(e.target.value.replace(/[^0-9.]/g, '') || 1);
        onChange({ ...item, quantity: value });
        setQuantity(value);
    };

    const handleRemove = () => {
        onRemove(item);
    };

    return (
        <li className="list-group-item">
            <div className="row">
                <div className="icon-cell col-lg-1 col-xl-1">
                    <p className="text-center text-secondary mt-3 mt-lg-0">
                        <i className={`fad fa-${item.product.icon} fa-2x`}></i>
                    </p>
                </div>
                <div className="name-cell col-lg-3 col-xl-4 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Name</label>
                    <p className="text-dark my-2">{item.product.name}</p>
                </div>
                <div className="price-cell col-lg-2 col-xl-2 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Price</label>
                    <p className="text-success text-end w-100 my-2">
                        {formatMoney(item.product.price)}
                    </p>
                </div>
                <div className="quantity-cell col-lg-3 col-xl-3 d-flex justify-content-between">
                    <label className="d-md-block d-lg-none fw-bold me-auto my-2">Quantity</label>
                    <p className="order-1 order-lg-0 ms-lg-auto ms-0 mb-0 w-50">
                        <input
                            type="number"
                            placeholder="Qty"
                            className="form-control text-end"
                            min={1}
                            max={100}
                            value={quantity}
                            onChange={handleUpdate}
                        />
                    </p>
                    <p className="order-0 order-lg-1 ms-lg-2 ms-0 me-2 me-lg-0 my-2">
                        <span className="text-muted" onClick={handleRemove}>
                            <span className="fas fa-trash fa-fw" />
                        </span>
                    </p>
                </div>
                <div className="total-cell col-lg-3 col-xl-2 d-flex justify-content-between">
                    <label className="d-md-block d-lg-none fw-bold my-2">Amount</label>
                    <p className="text-muted text-end w-100 my-2">{formatMoney(computeAmount())}</p>
                </div>
            </div>
        </li>
    );
};
